import React from 'react';

import ProductFlags from '../../../../components/product-flags/product-flags';
import TreadwellRankBanner from '../../../../components/treadwell-rank-banner/treadwell-rank-banner';

import { ProductData } from '../../../../shared/types/graphql-types';

import './product-list-card-highlight.scss';

interface ProductListCardHighlightProps {
  product: ProductData;
}

function ProductListCardHighlight(props: ProductListCardHighlightProps) {
  const { product } = props;
  const { rank } = product?.recommendationData || {};

  return (
    <div styleName="container">
      <div styleName="product-flags">
        <ProductFlags product={product} />
      </div>

      {rank && (
        <div styleName="treadwell-rank">
          <TreadwellRankBanner rank={rank} />
        </div>
      )}
    </div>
  );
}

export default ProductListCardHighlight;
